<template>
    <div class="container-fluid section-users mt-5">
        <div class="row">
            <carousel :navigationEnabled=true navigation-next-label="" navigation-prev-label="" :paginationEnabled="false" :per-page-custom="perPageCustom" :mouse-drag=false class="carousel-personeel">
                <slide v-for="item in items" :key="item.id">
                    <div class="card card-user" v-data-href>
                        <div v-html="item.img" class="card-img-top"></div>
                        <div class="card-body">
                            <p class="card-title mt-3">{{ item.name }}</p>
                            <p class="card-function">{{ item.functie }}</p>
                        </div>
                        <div class="overlay" v-if="item.tekst">
                            <div class="overlay-content">
                                <a :href="item.url" class="btn btn-link">Meer over {{ item.name }}</a>
                            </div>
                        </div>
                    </div>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
        },
    },
    data() {
        return {
            perPageCustom: [[0,1], [575,2], [768,3], [1280, 4], [1600, 5]]
        }
    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/components/Personeel.vue